import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Subject } from 'rxjs';

const CONTACT_CHANNEL_SLUG = 'presence-vip-channel-contact-';
const ACCOUNT_CHANNEL_SLUG = 'presence-vip-channel-account-';
declare let Pusher;

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  userChannel: any;
  pusher: any;
  accountChannel: any;

  constructor(private readonly authService: AuthService) {}

  async init() {
    try {
      const user = this.authService.currentUser;
      if (!user) return;
      this.pusher = new Pusher(import.meta.env.NG_APP_PUSHER_KEY, {
        cluster: import.meta.env.NG_APP_PUSHER_CLUSTER,
        enableStats: true,
        authEndpoint: `${import.meta.env.NG_APP_PUSHER_AUTH_URL}?account_contact_id=${user.id}`,
      });
      Pusher.logToConsole = import.meta.env.NG_APP_PRODUCTION !== 'true';
      this.userChannel = this.pusher.subscribe(`${CONTACT_CHANNEL_SLUG}${user.id}`);
      this.accountChannel = this.pusher.subscribe(`${ACCOUNT_CHANNEL_SLUG}${user.account?.id}`);
    } catch (error) {
      console.error(error);
    }
  }

  async subscribeEvent<T>(event: string, isAccountChannel = false): Promise<Subject<T>> {
    if (!this.pusher) await this.init();
    return new Promise(resolve => {
      setTimeout(() => {
        const channel = isAccountChannel ? this.accountChannel : this.userChannel;
        if (!channel) return;

        const subscription = new Subject<T>();
        channel.unbind(event);
        channel.bind(event, data => {
          subscription.next(data);
        });
        resolve(subscription);
      }, 3000);
    });
  }

  close() {
    this.pusher?.disconnect();
  }
}
